import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// prettier-ignore
// eslint-disable-next-line no-useless-escape
export const PASSWORD_MINIMUN_EIGHT_CHARACTERS_AT_LEAST_ONE_LETTER_AND_ONE_NUMBER = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9!_@./#&+-]{8,}$/;
export const PIN_MINIMUM_FOUR_MAXIMUM_FOUR_CHARACTERS_ONLY_NUMBERS = /^[0-9]+$/;

export function pinMatchingValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.get('pin')?.value === control.get('confirmPin')?.value ? null : { pin: { notMatch: true }, confirmPin: { notMatch: true }, notMatch: true };
  };
}

export function passwordMatchingValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password')?.value || '';
    const confirmPassword = control.get('confirmPassword')?.value || '';

    if (!password && !confirmPassword) {
      return null;
    }

    if (password === confirmPassword) {
      return null;
    }

    return {
      password: { notMatch: true },
      confirmPassword: { notMatch: true },
      notMatch: true,
    };
  };
}
